<template>
    <div class="Info por">
        <!-- <div class="InfoTop">
            <div class="InfoTit">联系我们</div>
            <div class="InfoTitMsg">中国心理卫生协会</div>
        </div>
        <div class="Contact">
            <div class="ContactDis">
                <div class="ContactItem">
                    <div class="ContactItemNum">
                        <div>134 0116 1990</div>
                    </div>
                    <div class="ContactItemDis">
                        <div>
                            <div class="ContactItemJob">学术大会注册联系人</div>
                            <div class="ContactItemName">联系人：沈老师</div>
                        </div>
                        <div>
                            <div class="iconfont icon-yonghuxinxi1"></div>
                        </div>
                    </div>
                </div>
                <div class="ContactItem">
                    <div class="ContactItemNum">
                        <div>010-64001762</div>
                        <div>010-64001762</div>
                    </div>
                    <div class="ContactItemDis">
                        <div>
                            <div class="ContactItemJob">会议联系人</div>
                            <div class="ContactItemName">联系人：龙老师</div>
                        </div>
                        <div>
                            <div class="iconfont icon-bianji3"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ContactDis">
                <div class="ContactItem">
                    <div class="ContactItemNum">
                        <div>134 0116 1990</div>
                    </div>
                    <div class="ContactItemDis">
                        <div>
                            <div class="ContactItemJob">协议会员联系人</div>
                            <div class="ContactItemName">联系人：沈老师</div>
                        </div>
                        <div>
                            <div class="iconfont icon-a-xieyileibiegongyingshangxieyileibie"></div>
                        </div>
                    </div>
                </div>
                <div class="ContactItem">
                    <div class="ContactItemNum">
                        <div>010-64001762</div>
                        <div>010-64001762</div>
                    </div>
                    <div class="ContactItemDis">
                        <div>
                            <div class="ContactItemJob">财务联系人</div>
                            <div class="ContactItemName">联系人：龙老师</div>
                        </div>
                        <div>
                            <div class="iconfont icon-caiwuguanli"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ContactDis">
                <div class="ContactItem">
                    <div class="ContactItemNum">
                        <div>hezuoshenqing@camh.org.cn</div>
                    </div>
                    <div class="ContactItemDis">
                        <div>
                            <div class="ContactItemJob">合作申请</div>
                        </div>
                        <div>
                            <div class="iconfont icon-hezuo"></div>
                        </div>
                    </div>
                </div>
                <div class="ContactItem">
                    <div class="ContactItemNum">
                        <div>010-64001762</div>
                    </div>
                    <div class="ContactItemDis">
                        <div>
                            <div class="ContactItemJob">媒体合作</div>
                            <div class="ContactItemName">联系人：龙老师</div>
                        </div>
                        <div>
                            <div class="iconfont icon-duomeiti"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        
        <!-- <div class="NoDataBtn NoDataBtn1 poa" @click="GoMySuggestion">联系我们</div>
        <el-dialog :visible.sync="suggestBlon" :width="Wid" :show-close="false" @close="suggestBlon=false">
            <div class="StepJiBen">
                <div class="StepJiBenItem">
                    <div class="StepJiBenItemTit"><span class="Tit">反馈类型</span></div>
                    <div class="StepJiBenItemVal">
                        <el-select class="WidMax" size="medium" placeholder="请选择" v-model="SetData.group">
                            <el-option label="项目" value="项目"></el-option>
                            <el-option label="专业人员注册" value="专业人员注册"></el-option>
                            <el-option label="专业机构注册" value="专业机构注册"></el-option>
                            <el-option label="伦理投诉" value="伦理投诉"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="StepJiBenItem">
                    <div class="StepJiBenItemTit"><span class="Tit">反馈内容</span></div>
                    <div class="StepJiBenItemVal">
                        <el-input type="textarea" :rows="6" placeholder="请输入" v-model="SetData.content"></el-input>
                    </div>
                </div>
            </div>
            <div class="OrderBtns">
                <div class="OrderBtn" @click="suggestBlon=false">取消</div>
                <div class="OrderBtn BgBlue" @click="SetInfo">提交</div>
            </div>
        </el-dialog> -->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                Wid:"60%",
                suggestBlon: false,
                SetData:{
                    group:"",
                    content:"",
                },
            }
        },
        mounted() {
            
        },
        methods: {
            //跳转到我的建议
            GoMySuggestion() {
                this.suggestBlon = !this.suggestBlon;
            },
            SetInfo(){
                if(this.SetData.group == ""){this.$message.error("请选择反馈类型");return;}
                if(this.SetData.content ==""){this.$message.error("请输入反馈内容");return;}
                var Quy = JSON.parse(JSON.stringify(this.SetData))
                this.$post("api/user/addAdvise",Quy).then(res => {
                     if(res.data.code == 1){
                         this.page = 1;
                         this.SetData = {};
                         this.GoMySuggestion();
                         this.$message.success(res.data.msg)
                     }else{
                         this.$message.error(res.data.msg)
                     }
                })  
            },
        },
    }
</script>
<style scoped>
    .InfoTop{
         display: flex;
         align-items: center;
         justify-content: space-between;
         padding: 20px 0;
     }
    .InfoTit{
         color: #000;
         font-size: 16px;
     }
     .InfoTitMsg{
         font-weight: 400;
         font-size: 16px;
         color: #0385EB;
     }
     .Contact{
         width: 100%;
     }
     .ContactDis{
         display: flex;
         align-items: center;
         flex-wrap: wrap;
         gap: 1rem;
     }
     .ContactItem{
        margin-top: 15px;
        flex: 1 0 340px;
        border: 1px solid #EEEEEE;
        padding: 20px;
        cursor: pointer;
        border-radius: 10px;
     }
     .ContactItemNum{
         display: flex;
         align-items: center;
         gap: 1rem;
         font-weight: 400;
         font-size: 16px;
         color: #000000;
     }
     .ContactItemDis{
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-top: 20px;
     }
     .ContactItemJob{
         font-weight: 400;
         font-size: 16px;
         color: #666666;
         padding-bottom: 10px;
     }
     .ContactItemName{
         font-weight: 400;
         font-size: 16px;
         color: #999999;
     }
     .ContactItemDis .iconfont {
        font-size: 40px;
        margin-top: 10px;
        color: #ddd;
     }
     .ContactItem:hover{
         box-shadow: 5px 0px 25px 0px #e5e5e5;
     }
    .ContactItem:hover .ContactItemNum,
    .ContactItem:hover .iconfont{
         color: #0385EB;
     }
    .NoDataBtn {
        cursor: pointer;
        width: 90px;
        font-weight: 400;
        font-size: 20px;
        color: #FFFFFF;
        padding: 7px 15px;
        border-radius: 20px;
        background: #0385EB;
        margin: 0 auto;
    }
    .NoDataBtn1 {
        margin: 0;
        margin-bottom: 10px;
        text-align: center;
        font-size: 16px;
    }
    .por {
        position: relative;
        height: 100%;
    }
    .poa {
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .StepJiBen{
       width: 100%;
   }
   .StepJiBenItem{
       display: flex;
       align-items: center;
       margin-bottom: 40px;
   }
   .StepJiBenItemTit{
       width: 135px;
       text-align: right;
       margin-right: 20px;
   }
   .StepJiBenItemTit .Tit{
       font-weight: 400;
       font-size: 16px;
       color: #999;
   }
   .StepJiBenItemVal{
       flex: 1;
   }
   .StepJiBenItemVal .WidMax{
       width: 100%;
   }
   .OrderBtns{
       display: flex;
       align-items: center;
       justify-content: center;
       margin: 20px 0;
   }
   .OrderBtn{
        padding: 5px 40px;
        background: #FFFFFF;
        font-weight: 400;
        font-size: 18px;
        color: #0385EB;
        border-radius: 30px;
        border: 1px solid #0385EB;
        margin-right: 20px;
        cursor: pointer;
   }
   .OrderBtn.BgBlue{
       background: #0385EB;
       color: #fff;
   }
</style>